<!--观看人数-->
<template>
  <div :class="[isPc ? 'online-num-contain-pc' : 'online-num-contain']">
    <div class="left-p">
      <van-icon name="friends" />
    </div>
    <div class="right-p">{{people}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    people: {
      type: Number,
      default: 0,
    }
  },
  computed:{
    ...mapState(['isPc'])
  }
}
</script>

<style lang="less" scoped>
.online-num-contain-pc{
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .left-p {
    padding: 0.05rem 0.06rem 0.01rem 0.04rem;
    height: 100%;
    display: flex;
    align-items: center;
    .van-icon {
      font-size: 0.25rem;
      color: #fff;
    }
  }
  .right-p {
    font-size: 0.19rem;
    color: #fff;
    padding: 0.03rem 0.06rem 0.05rem 0.08rem;
  }
}
.online-num-contain {
  border: 1px solid #2284E5;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 0.34rem;
  .left-p {
    background: #2284E5;
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px;
    padding: 0.05rem 0.06rem 0.01rem 0.04rem;
    height: 100%;
    display: flex;
    align-items: center;
    .van-icon {
      font-size: 0.25rem;
      color: #fff;
    }
  }
  .right-p {
    font-size: 0.15rem;
    color: #2284E5;
    padding: 0.03rem 0.06rem 0.05rem 0.08rem;
  }
}
</style>
